/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum FuelStatisticsSort {
    Ascending = 'ascending',
    Descending = 'descending'
}

export function FuelStatisticsSortFromJSON(json: any): FuelStatisticsSort {
    return FuelStatisticsSortFromJSONTyped(json, false);
}

export function FuelStatisticsSortFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelStatisticsSort {
    return json as FuelStatisticsSort;
}

export function FuelStatisticsSortToJSON(value?: FuelStatisticsSort | null): any {
    return value as any;
}

